import { useEffect, useRef } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Header from './Header';

const KONAMI_CODE = [
    'ArrowUp', 'ArrowUp',
    'ArrowDown', 'ArrowDown',
    'ArrowLeft', 'ArrowRight',
    'ArrowLeft', 'ArrowRight',
    'b', 'a',
];

const Layout = () => {
    const navigate = useNavigate();
    const progress = useRef(0);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === KONAMI_CODE[progress.current]) {
                progress.current += 1;
                if (progress.current === KONAMI_CODE.length) {
                    progress.current = 0;
                    navigate('/contexte-technique');
                }
            } else {
                progress.current = event.key === KONAMI_CODE[0] ? 1 : 0;
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [navigate]);

    return (
        <section className="hero is-fullheight is-default is-bold">
            <Header />
            <Outlet />
        </section>
    );
};

export default Layout;
